<template>
  <TheExercises
    class="h-dvh"
    :section-slug="sectionSlug"
    :topic-slug="topicSlug"
  />
</template>

<script>
import TheExercises from '@/components/Hub/Exercises/TheExercises.vue'

export default {
  name: 'HubExercisesPage',

  components: { TheExercises },

  computed: {
    sectionSlug() {
      return this.$route.params.sectionSlug
    },
    topicSlug() {
      return this.$route.params.topicSlug
    }
  }
}
</script>
